import { Box, BoxProps, Button, Icon } from '@hover/blueprint';
import {
  iChevronLeft,
  iChevronRight,
  iChevronsLeft,
  iChevronsRight,
} from '@hover/icons';
import React, { Dispatch, FC, SetStateAction } from 'react';
import PaginationPagesDesktop from './PaginationPagesDeskptop';
import PaginationPagesMobile from './PaginationPagesMobile';

interface Props extends BoxProps {
  prevPageNumber: number | null;
  setPageNumber: Dispatch<SetStateAction<number>>;
  currentPageNumber: number;
  nextPageNumber: number | null;
  totalPagesNumber: number | null;
}

const PaginationGroup: FC<Props> = ({
  currentPageNumber,
  nextPageNumber,
  prevPageNumber,
  setPageNumber,
  totalPagesNumber,
  mb,
  mt,
}) => {
  function handleNext() {
    if (nextPageNumber) setPageNumber(nextPageNumber);
  }

  function handleEnd() {
    if (totalPagesNumber) setPageNumber(totalPagesNumber);
  }

  function handlePrev() {
    if (prevPageNumber) setPageNumber(prevPageNumber);
  }

  function handleFirst() {
    if (prevPageNumber) setPageNumber(1);
  }

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      mb={mb}
      mt={mt}
    >
      <Button
        isDisabled={!prevPageNumber}
        color="neutral"
        fill="minimal"
        shape="square"
        onClick={() => {
          handleFirst();
        }}
      >
        <Icon
          color={prevPageNumber ? 'brandNavy.500' : 'default'}
          size="medium"
          icon={iChevronsLeft}
        />
      </Button>
      <Button
        isDisabled={!prevPageNumber}
        color="neutral"
        fill="minimal"
        shape="square"
        onClick={() => {
          handlePrev();
        }}
      >
        <Icon
          color={prevPageNumber ? 'brandNavy.500' : 'default'}
          size="medium"
          icon={iChevronLeft}
        />
      </Button>
      <PaginationPagesDesktop
        setPageNumber={setPageNumber}
        currentPageNumber={currentPageNumber}
        prevPageNumber={prevPageNumber}
        nextPageNumber={nextPageNumber}
      />
      <PaginationPagesMobile
        setPageNumber={setPageNumber}
        currentPageNumber={currentPageNumber}
        totalPagesNumber={totalPagesNumber}
      />
      <Button
        isDisabled={!nextPageNumber}
        color="neutral"
        fill="minimal"
        shape="square"
        onClick={() => {
          handleNext();
        }}
      >
        <Icon
          size="medium"
          color={nextPageNumber ? 'brandNavy.500' : 'default'}
          icon={iChevronRight}
        />
      </Button>
      <Button
        isDisabled={!totalPagesNumber}
        color="neutral"
        fill="minimal"
        shape="square"
        onClick={() => {
          handleEnd();
        }}
      >
        <Icon
          size="medium"
          color={nextPageNumber ? 'brandNavy.500' : 'default'}
          icon={iChevronsRight}
        />
      </Button>
    </Box>
  );
};

export default PaginationGroup;
